import React from 'react';
import { useSelector } from 'react-redux';
import { TRootState } from '../../reducers';

type TSubmitButtonProps = {
    className: string,
    onClick: (e: any) => void,
    propName: string,
    children: any,
}

export default function SubmitButton({
    className,
    onClick,
    propName,
    children,
}: TSubmitButtonProps) {
    const loading = useSelector((state: TRootState) => state.loading[propName]);

    const newClassName = className + (loading ? ' loading' : '');
    return (
        <button
            className={newClassName}
            type="submit"
            onClick={onClick}
        >
            {loading ? 'Submitting...' : children}
        </button>
    );
}
